/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleRepeatingSchedule {
    getFixupPrototypeFunction() { return BillingRuleRepeatingSchedule.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleRepeatingSchedule>): BillingRuleRepeatingSchedule {
        let obj = Object.assign(new BillingRuleRepeatingSchedule(), model);
        BillingRuleRepeatingSchedule.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleRepeatingSchedule>): BillingRuleRepeatingSchedule {
        if (!model) return null;
        return BillingRuleRepeatingSchedule.newInstance(<BillingRuleRepeatingSchedule> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleRepeatingSchedule) {
        if (!obj) return;

        models.BillingRuleRepeatingSchedule.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleRepeatingSchedule): boolean {
        Object.setPrototypeOf(obj, BillingRuleRepeatingSchedule.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
    }

    /**
     * Start date of the billing rule
     */
    start_date: Date;

    /**
     * Frequency of the billing rule
     */
    frequency: models.BillingFrequency;

}
